import { beam } from '@styles/colors/themes';
import styled from 'styled-components';
import { ReactComponent as ArrowDownIcon } from '@assets/svg/arrow-down.svg';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 24px;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  max-width: 457px;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 16px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
`;

export const Close = styled.div`
  cursor: pointer;
`;

export const Back = styled.img`
  cursor: pointer;
`;
export const DownImg = styled(ArrowDownIcon)`
  margin-left: -26px;
  margin-top: 15px;
`;
export const Label = styled.div`
  font-size: 12px;
  color: #474d66;
  font-weight: 500;
  margin-bottom: 4px;

  margin-top: 24px;

  &.picture {
    margin-top: 0;
  }
`;

export const Line = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
`;

export const Confirm = styled.button`
  height: 36px;
  padding: 0 16px;
  color: #fff;
  background: #1371fe;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;

  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;

  &.pictureInputs {
    width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  display: flex;
  width: 323px;
  height: 36px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 12px;

  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;
export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const Divider = styled.div`
  height: 24px;
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;
export const Tooltip = styled.div`
  z-index: 999;
  display: flex;
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 418px;
`;

export const YesNo = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-left: 12px;
  margin-right: 16px;
  line-height: 20px;
  /* identical to box height, or 143% */

  /* Neutral/N800 (Text Normal) */
  color: #474d66;
`;

export const TextClick = styled.div`
  padding-right: 24px;
  margin-left: 15px;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: pre-wrap;
  font: inherit;
`;

export const ShortClose = styled.img`
  cursor: pointer;
  height: 10px;
  display: flex;
  width: 10px;
  z-index: 999;
  color: #8f95b2 !important;
`;

export const Plus = styled.img`
  cursor: pointer;
  align-self: center;
  justify-self: center;
  display: flex;
  height: 12px;
  width: 12px;
  color: #8f95b2 !important;
`;

export const ImageClick = styled.div`
  padding-right: 12px;
`;

export const GridDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const ButtonClick = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  color: #474d66;
  line-height: 16px;
  font-weight: 400;
  border: 1px solid #d8dae5;
  box-sizing: border-box;
  border-radius: 8px;
  margin-bottom: 8px;
  margin-right: 8px;
  height: 36px;

  max-width: calc(466px - 48px);
`;

export const ButtonPlus = styled(ButtonClick)`
  min-width: unset;
  max-width: unset;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  width: 36px;
  height: 36px;
`;
